import type { ReactNode } from 'react';

interface ContentContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * Editorial section wrapper. Intentionally has NO card chrome
 * (no border, no background, no rounded corners, no shadow).
 *
 * Sections are separated by generous vertical spacing at the page level
 * (e.g. `space-y-10 md:space-y-14` on the parent PageContainer). If a
 * page needs a visual rule between sections, apply `border-t border-gray-200
 * pt-10` directly on the section instead of wrapping in card chrome.
 *
 * Background rationale: the prior card-chrome version produced "card soup"
 * on detail pages — every section looked identical, no hierarchy, no rhythm.
 * Editorial layouts (Michelin Guide style) lean on typography + whitespace
 * for structure, not rounded rectangles.
 */
export const ContentContainer = ({ children, className = '' }: ContentContainerProps) => {
  return (
    <section className={className}>
      {children}
    </section>
  );
};